(function () {
  var flickityMap = new WeakMap();
  var resizeTimer;

  function isDesktop() {
    return window.innerWidth >= 768;
  }

  function getOptions() {
    var mobile = !isDesktop();

    return {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: !mobile,
      draggable: true,
      freeScroll: true,
      wrapAround: false,
      friction: 0.25,
      selectedAttraction: 0.025,
      groupCells: mobile ? 1 : false,
    };
  }

  function initFlickityForPanel(panel) {
    var carousel = panel.querySelector('.flickity-carousel');
    if (!carousel || typeof Flickity === 'undefined') return null;

    var existing = flickityMap.get(carousel) || Flickity.data(carousel);
    if (existing) {
      existing.resize();
      return existing;
    }

    var flkty = new Flickity(carousel, getOptions());
    flickityMap.set(carousel, flkty);
    return flkty;
  }

  function initTabCollection(root) {
    if (!root || root.dataset.tabCollectionInit === 'true') return;
    root.dataset.tabCollectionInit = 'true';

    var buttons = root.querySelectorAll('.tab-btn');
    var panels = root.querySelectorAll('.tab-panel');

    function activateTab(index) {
      buttons.forEach(function (btn, idx) {
        btn.classList.toggle('is-active', idx === index);
      });

      panels.forEach(function (panel, idx) {
        var isActive = idx === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          initFlickityForPanel(panel);
        }
      });
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        activateTab(index);
      });
    });

    if (buttons.length > 0) {
      activateTab(0);
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.ats-collection-tabs[data-tab-collection]').forEach(initTabCollection);
  }

  function destroyIn(root) {
    var scope = root || document;
    scope.querySelectorAll('.ats-collection-tabs .flickity-carousel').forEach(function (el) {
      var flkty = flickityMap.get(el) || Flickity.data(el);
      if (flkty) {
        flkty.destroy();
        flickityMap.delete(el);
      }
    });

    scope.querySelectorAll('.ats-collection-tabs[data-tab-collection]').forEach(function (section) {
      delete section.dataset.tabCollectionInit;
    });
  }

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document
        .querySelectorAll('.ats-collection-tabs .tab-panel.is-active .flickity-carousel')
        .forEach(function (el) {
          var flkty = flickityMap.get(el) || Flickity.data(el);
          if (flkty) {
            flkty.resize();
          }
        });
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyIn(event.target);
  });
})();
